import { render, staticRenderFns } from "./DisclaimerDialog.vue?vue&type=template&id=e299ef04&scoped=true&"
import script from "./DisclaimerDialog.vue?vue&type=script&lang=js&"
export * from "./DisclaimerDialog.vue?vue&type=script&lang=js&"
import style0 from "./DisclaimerDialog.vue?vue&type=style&index=0&id=e299ef04&scoped=true&lang=less&"
import style1 from "./DisclaimerDialog.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e299ef04",
  null
  
)

export default component.exports